<template>
  <main>
    <div class="flex justify-end gap-x-8">
      <div class="text-right">
        <span class="capitalize text-gray-700">Profile view left</span>
        <h2 class="text-brand-black text-3xl">{{ profileViewUsage?.remaining_quantity }}</h2>
      </div>
      <div class="text-right">
        <span class="capitalize text-gray-700">Total profile views</span>
        <h2 class="text-brand-black text-3xl">{{ profileViewUsage?.total_quantity }}</h2>
      </div>
    </div>

    <Tab :numberOfTabs="tabs" :currentTab="tabNumber" borderColor="border-brand-black" @changeTab="changeTab" spread>
      <div v-if="tabNumber == 1" id="about" role="tabpanel" aria-labelledby="about-tab" class="grid mt-2">
        <talents />
      </div>
      <div v-if="tabNumber == 2" id="location" role="tabpanel" aria-labelledby="location-tab" class="grid mt-2">
        <talent-pool />
      </div>
    </Tab>
  </main>
</template>

<script setup>
import Talents from '../components/talent/Talents.vue';
import TalentPool from '@/components/talent/TalentPool.vue';
import Tab from '@/components/Tab.vue';
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { initFlowbite } from 'flowbite';

const store = useStore();
const subUsages = ref([]);
const tabNumber = ref(1);
const tabs = ref([
  {
    name: 'Talents',
  },
  {
    name: 'Talent Pool',
  },
]);

const changeTab = (value) => {
  tabNumber.value = value;
  // window.scrollTo(0, 50);
};

const userDetails = computed(() => {
  return store.state.auth.userDetails;
});

const profileViewUsage = computed(() => {
  const profiles = subUsages.value.filter((item) => item.feature_alias == 'talent_profile');
  if (!profiles.length) return {total_quantity : 0, remaining_quantity: 0};
  return profiles[0];
});

const getSubUsage = async () => {
  try {
    subUsages.value = await store.dispatch('global/getSubUsage');
  } catch (error) {
    alert(errorMessage(error), {
      timeout: 3000,
      hideProgressBar: true,
    });
  }
};

onMounted(async () => {
  await getSubUsage();
  initFlowbite();
});
</script>
